import { ClickEvent, Label, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutAutoRateLookup } from "./autogen/AutogenLayoutAutoRateLookup";
import { Navigation } from "@mcleod/core";

export class AutoRateLookup extends AutogenLayoutAutoRateLookup {

    tableAutoRatesOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const labelId = tableRow.findComponentById("labelId") as Label;
        if (labelId) {
            labelId.addUnderlineWhenMouseOver();
        }
    }

    labelIdOnClick(event: ClickEvent) {
        const labelId = event.target as Label;
        Navigation.navigateTo(`lme/dispatch/rates/AutoRate?mode=update&key=${labelId.text}`, { newTab: true });
    }
}